import type React from 'react';

import type { AudienceBuilderAllowedFilter } from '../../../../../shared/types';

import { InputField } from './components/InputField';
import { SelectField } from './components/SelectField';
import { useFilterValueField } from './hooks/useFilterValueField';

export const FilterValueField: React.FC<{
	fieldName: string;
	fieldTypeName: string;
	allowedFilters: readonly AudienceBuilderAllowedFilter[];
}> = ({ fieldName, fieldTypeName, allowedFilters }) => {
	const {
		data: { filterSelected },
	} = useFilterValueField({ fieldTypeName, allowedFilters });
	if (!filterSelected?.type) return <div className="admin:flex-1" />;
	if (!filterSelected.values) {
		return <InputField fieldName={fieldName} placeholder={filterSelected.name} />;
	}
	return (
		<SelectField
			fieldName={fieldName}
			fieldValues={filterSelected.values}
			placeholder={`Select ${filterSelected.name}`}
		/>
	);
};
